






















import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GChatFileMessage',
  props: {
    fileName: { type: String as PropType<string> },
    fileSize: { type: String as PropType<string> },
    fileFormat: { type: String as PropType<string> },
    downloadUrl: { type: String as PropType<string> },
    isImage: { type: Boolean as PropType<boolean>, default: false },
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
  },
});
